import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import SingleHazardControl from '../SingleHazardControl';
import EditHazardControl from '../EditHazardControl';
import DeleteHazardControlDialog from '../../../containers/DeleteHazardControlDialog';

const useStyles = makeStyles((theme) => ({
  controlsListContainer: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 650
  },
  boldText: {
    fontWeight: 800
  }
}));

const ControlsList = (props) => {
  const classes = useStyles();
  const {
    controls,
    userId,
    enableEditHazardControl,
    isEditControlEnabled,
    controlBeingEdited,
    handleEditHazardControlInputChange,
    handleSaveHazardControlClick,
    showDeleteControlDialog,
    handleOpenDeleteHazardControlClick,
    openDocumentListDialog
  } = props;

  return (
    <React.Fragment>
      {showDeleteControlDialog ? <DeleteHazardControlDialog /> : null}
      <TableContainer
        component={Paper}
        className={classes.controlsListContainer}
      >
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.boldText}>Controls</TableCell>
              <TableCell className={classes.boldText}>Detail</TableCell>
              <TableCell className={classes.boldText}>Document</TableCell>
              <TableCell
                className={classes.boldText}
                align="center"
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {controls.map((control) => {
              const isEditMode =
                isEditControlEnabled && control.id === controlBeingEdited.id;

              return (
                <TableRow key={control.id}>
                  {isEditMode ? (
                    <EditHazardControl
                      control={controlBeingEdited}
                      userId={userId}
                      handleEditHazardControlInputChange={
                        handleEditHazardControlInputChange
                      }
                      enableEditHazardControl={enableEditHazardControl}
                      handleSaveHazardControlClick={
                        handleSaveHazardControlClick
                      }
                      openDocumentListDialog={openDocumentListDialog}
                    />
                  ) : (
                    <SingleHazardControl
                      control={control}
                      userId={userId}
                      enableEditHazardControl={enableEditHazardControl}
                      handleOpenDeleteHazardControlClick={
                        handleOpenDeleteHazardControlClick
                      }
                    />
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default ControlsList;
